module.exports = __webpack_public_path__ + "img/act.bee9489f.svg";